<script lang="ts">
  import { header_menu_height } from "$lib/data";
  import { page } from "$app/stores";
  import { fly } from "svelte/transition";
  import {
    CaretDown,
    ArrowFatLineLeft,
    ArrowFatLineRight,
  } from "phosphor-svelte";
  import { afterNavigate, goto } from "$app/navigation";
  export let guests: number;
  export let episode: number;
  export let episodeNumber: number;
  export let galleryCount: number;
  export let videoCount: number;
  export let bonusCount: number;
  export let achievementCount: number;
  export let in_revue: string;
  export let guest_host: boolean = false;

  afterNavigate(() => {
    expanded = false;
  });

  $: base = `/episodes/episode-${episode}`;

  let height: number;
  let expanded: boolean = false;

  let window_width: number;
  let menu_width: number;
  let scroll_y: number;

  $: if (scroll_y > 100 && expanded) {
    expanded = false;
  }
</script>

<svelte:window bind:innerWidth={window_width} bind:scrollY={scroll_y} />

{#if expanded}
  <div
    class="backdrop"
    on:click={() => (expanded = false)}
    on:keypress={() => (expanded = false)}
    role="button"
    tabindex="-1"
  />
  <svg
    style="left: calc( 50% - 10px )"
    style:top="calc({$header_menu_height}px + 3.7rem)"
    class="nib"
    in:fly={{ delay: 150, duration: 200, y: 10 }}
    out:fly={{ duration: 200, y: 10 }}
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="20px"
    height="15px"
    viewBox="0 0 20 14.308"
    enable-background="new 0 0 20 14.308"
    xml:space="preserve"
  >
    <path
      fill="#FFFFFF"
      d="M20,15.712H0c0,0,8.394-13.702,8.999-14.308s1.37-0.631,2.002,0S20,15.712,20,15.712z"
    />
  </svg>
  <nav
    bind:clientWidth={menu_width}
    bind:clientHeight={height}
    style:transform="translateY({expanded ? 0 : height - 59}px)"
    style:top="calc({$header_menu_height}px + 4.5rem)"
    style:left="{(window_width - menu_width) / 2}px"
    transition:fly={{ duration: 200, y: -20 }}
  >
    <div>
      <a href={base} class:active={$page.url.pathname == base}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          ><path
            d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
          /><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" /></svg
        >
        The Episode
      </a>
      {#if guests > 0}
        <a
          href="{base}/guests"
          class:active={$page.url.pathname == base + "/guests"}
        >
          {#if guests > 1 || guest_host}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              ><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle
                cx="9"
                cy="7"
                r="4"
              /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path
                d="M16 3.13a4 4 0 0 1 0 7.75"
              /></svg
            >
            The Guests
          {:else}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              ><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle
                cx="12"
                cy="7"
                r="4"
              /></svg
            >
            The Guest
          {/if}
        </a>
      {/if}
      <a
        href="{base}/gallery"
        class:active={$page.url.pathname == base + "/gallery"}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          ><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle
            cx="8.5"
            cy="8.5"
            r="1.5"
          /><polyline points="21 15 16 10 5 21" /></svg
        >
        Contribution Gallery
        {#if galleryCount > 0}
          <span class="count">
            {galleryCount}
          </span>
        {/if}
      </a>
      <a
        href="{base}/process-videos"
        class:active={$page.url.pathname == base + "/process-videos"}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          ><polygon points="23 7 16 12 23 17 23 7" /><rect
            x="1"
            y="5"
            width="15"
            height="14"
            rx="2"
            ry="2"
          /></svg
        >
        Process Videos
        {#if videoCount > 0}
          <span class="count">
            {videoCount}
          </span>
        {/if}
      </a>
      {#if in_revue !== ""}
        <a
          href="{base}/in-revue"
          class:active={$page.url.pathname == base + "/in-revue"}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path
              d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
            /><polygon
              points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
            /></svg
          >
          In Revue
        </a>
      {/if}
      {#if episodeNumber > 106}
        <a
          href="{base}/achievements"
          class:active={$page.url.pathname == base + "/achievements"}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><circle cx="12" cy="8" r="7" /><polyline
              points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"
            /></svg
          >
          Achievements
          {#if achievementCount > 0}
            <span class="count">
              {achievementCount}
            </span>
          {/if}
        </a>
      {/if}
      <a
        href="{base}/bonus"
        class:active={$page.url.pathname == base + "/extras"}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          ><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle
            cx="8.5"
            cy="8.5"
            r="1.5"
          /><polyline points="21 15 16 10 5 21" /></svg
        >
        Extras Gallery
        {#if bonusCount > 0}
          <span class="count">
            {bonusCount}
          </span>
        {/if}
      </a>
      <footer>
        <a href="/episodes/">
          <svg
            fill="none"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M11.7071 5.29289C12.0976 5.68342 12.0976 6.31658 11.7071 6.70711L7.41421 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.41421L11.7071 17.2929C12.0976 17.6834 12.0976 18.3166 11.7071 18.7071C11.3166 19.0976 10.6834 19.0976 10.2929 18.7071L4.29289 12.7071C4.10536 12.5196 4 12.2652 4 12C4 11.7348 4.10536 11.4804 4.29289 11.2929L10.2929 5.29289C10.6834 4.90237 11.3166 4.90237 11.7071 5.29289Z"
            />
          </svg>
          <span> Back To Episodes </span>
        </a>
      </footer>
    </div>
  </nav>
{/if}
<div class="launch" style:top="{$header_menu_height}px">
  <button
    disabled={episodeNumber === 1}
    on:click={goto(`/episodes/episode-${episodeNumber - 1}/`)}
  >
    <ArrowFatLineLeft />
  </button>
  <button on:click={() => (expanded = !expanded)}>
    Episode #{episode} Menu <CaretDown />
  </button>
  <button
    disabled={episodeNumber === $page.data.stats.total_episodes}
    on:click={goto(`/episodes/episode-${episodeNumber + 1}/`)}
  >
    <ArrowFatLineRight />
  </button>
</div>

<style>
  .launch {
    width: 100%;
    position: absolute;
    left: 0;
    background: var(--background);
    height: 5rem;
    padding: 0 1.2rem;
    z-index: 5;
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
  }
  .launch button {
    border: 1px solid var(--comment_accent);
    background: white;
    color: var(--title);
    box-shadow: var(--shadow);
    padding: 0.6rem 1.1rem;
    border-radius: 0.75rem;
    font-weight: bold;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .launch button:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 6;
  }

  .nib {
    position: absolute;
    z-index: 7;
  }

  nav {
    position: absolute;
    background: white;
    z-index: 6;
    width: 100%;
    box-shadow: var(--shadow);
    transition: all 500ms cubic-bezier(0.34, 1.56, 0.64, 1);
    width: 90%;
    max-width: 400px;
    border-radius: 0.6rem;
  }
  nav footer {
    border-top: 1px solid var(--dots);
  }
  nav footer a {
    font-size: 0.7rem;
    color: var(--offDark);
  }
  nav footer a svg {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 1rem;
    fill: var(--offDark);
  }
  nav a {
    border: none;
    background: transparent;
    display: flex;
    padding: 0.75rem 1rem;
    cursor: pointer;
    flex-flow: row;
    text-decoration: none;
    align-items: center;
    margin: 0.5rem;
    color: var(--title);
    border-radius: 0.5rem;
    font-size: 0.9rem;
    position: relative;
  }
  nav a .count {
    position: absolute;
    right: 3px;
    font-size: 0.8rem;
    font-family: "Open Sans", sans-serif;
    display: grid;
    place-content: center;
    padding: 0.5rem;
    border-radius: 0.5rem;
    color: var(--secondary);
  }
  nav a.active {
    background: radial-gradient(circle, #dceaf0 0%, #f0f5f7 100%);
  }
  nav a svg {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 1rem;
    stroke: var(--offDark);
  }
</style>
